export default __webpack_public_path__ + "static/media/passive_income.33ab13d5.png";